<form aria-labelledby="title" [formGroup]="loginForm" (ngSubmit)="onSubmit()">

  <div class="alert alert-danger" *ngIf="(state.get('serverError') | async) === true" i18n>Возникла ошибка. Попробуйте позднее</div>
  <div class="alert alert-danger" *ngIf="(state.get('lockedError') | async) === true" i18n>Временная блокировка. Вы ввели неверные данные 5 раз. Попробуйте позднее</div>
  <div class="alert alert-danger" i18n *ngIf="(state.get('status') | async) === 403">Неверный логин или пароль</div>

  <div *ngIf="isLoginByPhone()" class="form-control-group">
    <label class="label" for="input-phone" i18n="@@PhoneNumber">Телефон</label>
    <input
      i18n-placeholder="@@EnterDigitsOnly"
      placeholder="Вводите только цифры"
      phoneMask
      nbInput
      fullWidth
      formControlName="login"
      type="tel"
      maxlength="18"
      name="phone"
      id="input-phone"
    >
  </div>

  <div *ngIf="!isLoginByPhone()" class="form-control-group">
    <label class="label" for="input-phone" i18n="@@EmailLogin">Email</label>
    <input
      nbInput
      formControlName="login"
      fullWidth
      placeholder="example@mail.ru"
      autocomplete="off"
      required
    >
    <div *ngIf="loginForm.controls.login.errors?.email && loginForm.controls.login.touched" class="invalid-feedback">
      Укажите email
    </div>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-password" i18n="@@Password">Пароль</label>
    <div class="pass-field">
      <nb-form-field>
        <input nbInput
               minlength="6"
               size="large"
               fullWidth
               formControlName="password"
               [type]="isShowPass ? 'text' : 'password'"
               name="password"
        >
        <button nbSuffix nbButton type="button" (click)="togglePass()" style="background: none; border: none">
          <nb-icon [icon]="isShowPass ? 'eye-outline' : 'eye-off-2-outline'"/>
        </button>
      </nb-form-field>
    </div>
  </div>
    <a class="login-link" [routerLink]="[]" (click)="forgot()" i18n="@@ForgotPassword">Забыли пароль?</a>


    <div class="form-control-group form-content__btn">
    <button [disabled]="!loginForm.valid" class="btn-primary"
            status="control"
            size="large"
            i18n="@@SignIn"
            type="submit"
    >
      Войти
    </button>
  </div>
  <div class="divider"></div>
  <div style="text-align: center; margin: 15px 0 0; line-height: 2em">
    <a class="login-link" [routerLink]="['/cabinet','sign-up']" (click)="close()" i18n="@@NotRegisteredYet">Еще не зарегистрированы?</a>
  </div>
</form>
